import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import AdditionalInformation from './additional_information'
import { Boolean, TextInput } from '../ui'

export default class ColouristAnimatorPostSkills extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                'post_3d_rendering',
                'post_3d_rendering_software',
                'post_3d_graphics',
                'post_3d_graphics_software',
                'post_vr_stitching',
                'post_vr_stitching_software',
                'post_dcp',
                'post_dcp_software',
                'post_vfx',
                'post_vfx_software',
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let threeDeeRenderingSoftware = null
        let threeDeeGraphicsSoftware = null
        let vrStitchingSoftware = null
        let dcpSoftware = null
        let vfxSoftware = null

        if (getProperty(this.props.data, 'post_3d_rendering', false) === true) {
            threeDeeRenderingSoftware = (
                <TextInput
                    error={ errors.post_3d_rendering_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_3d_rendering_software"
                    placeholder="What software do you use?"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_3d_rendering_software') }
                />
            )
        }

        if (getProperty(this.props.data, 'post_3d_graphics', false) === true) {
            threeDeeGraphicsSoftware = (
                <TextInput
                    error={ errors.post_3d_graphics_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_3d_graphics_software"
                    placeholder="What software do you use?"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_3d_graphics_software') }
                />
            )
        }

        if (getProperty(this.props.data, 'post_vr_stitching', false) === true) {
            vrStitchingSoftware = (
                <TextInput
                    error={ errors.post_vr_stitching_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_vr_stitching_software"
                    placeholder="What software do you use?"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_vr_stitching_software') }
                />
            )
        }

        if (getProperty(this.props.data, 'post_dcp', false) === true) {
            dcpSoftware = (
                <TextInput
                    error={ errors.post_dcp_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_dcp_software"
                    placeholder="What software do you use?"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_dcp_software') }
                />
            )
        }

        if (getProperty(this.props.data, 'post_vfx', false) === true) {
            vfxSoftware = (
                <TextInput
                    error={ errors.post_vfx_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_vfx_software"
                    placeholder="What software do you use?"
                    type="textarea"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_vfx_software') }
                />
            )
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Post Skills
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Boolean
                            error={ errors.post_3d_rendering }
                            label="3D Rendering?"
                            name="post_3d_rendering"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_3d_rendering') }
                        />
                        { threeDeeRenderingSoftware }
                        <Boolean
                            error={ errors.post_3d_graphics }
                            label="3D Graphics & Animation?"
                            name="post_3d_graphics"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_3d_graphics') }
                        />
                        { threeDeeGraphicsSoftware }
                        <Boolean
                            error={ errors.post_vr_stitching }
                            label="VR Stitching?"
                            name="post_vr_stitching"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_vr_stitching') }
                        />
                        { vrStitchingSoftware }
                        <Boolean
                            error={ errors.post_dcp }
                            label="DCP?"
                            name="post_dcp"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_dcp') }
                        />
                        { dcpSoftware }
                        <Boolean
                            error={ errors.post_vfx }
                            label="VFX?"
                            name="post_vfx"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_vfx') }
                        />
                        { vfxSoftware }

                        <AdditionalInformation
                            { ...this.props }
                            label="Additional post skills"
                            wrapped={ false }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/colourist_animator_post_skills.js